import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/email-suppressions")({
  component: lazyRouteComponent(() => import("./-pages/admin.email-suppressions")),
  head: () => ({
    meta: [
      { title: "Email Suppressions · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
